const INITIAL_STATE: FullScreenState = {
  topBarCssClass: '',
  mainBarCssClass: '',
  navigationMenuCssClass: '',
  pageWrapperCssClass: '',
  iboxContentCssClass: '',
  footerCssClass: '',
  tooltipCssClass: '',
};

const SET_FULL_SCREEN_CONTENT: FullScreenState = {
  topBarCssClass: 'no-display',
  mainBarCssClass: 'no-display',
  navigationMenuCssClass: 'left',
  pageWrapperCssClass: 'full-page-wrapper',
  iboxContentCssClass: 'content-full-done',
  footerCssClass: 'm-n',
  tooltipCssClass: 'align-bottom',
};

const SET_INITIAL_CONTENT: FullScreenState = {
  topBarCssClass: '',
  mainBarCssClass: '',
  navigationMenuCssClass: '',
  pageWrapperCssClass: '',
  iboxContentCssClass: '',
  footerCssClass: '',
  tooltipCssClass: '',
};

const FULL_SCREEN_STATE = 'FULL_SCREEN_STATE';

export const FullScreenStateActions = {
  INIT: `${FULL_SCREEN_STATE}.FULL_SCREEN_STATE_INIT`,
  SET_FULL_SCREEN_CONTENT: `${FULL_SCREEN_STATE}.SET_FULL_SCREEN_CONTENT`,
  SET_INITIAL_CONTENT: `${FULL_SCREEN_STATE}.SET_INITIAL_CONTENT`,
};

export function fullScreenReducer(state: FullScreenState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case FullScreenStateActions.INIT:
      state = INITIAL_STATE;
      return state;
    case FullScreenStateActions.SET_FULL_SCREEN_CONTENT:
      state = SET_FULL_SCREEN_CONTENT;
      return state;
    case FullScreenStateActions.SET_INITIAL_CONTENT:
      state = SET_INITIAL_CONTENT;
      return state;
    default:
      return state;
  }
}


export interface FullScreenState {
  topBarCssClass: string;
  mainBarCssClass: string;
  navigationMenuCssClass: string;
  pageWrapperCssClass: string;
  iboxContentCssClass: string;
  footerCssClass: string;
  tooltipCssClass: string;
}
